/* APP */
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-pro/js/all';
import mixitup from 'mixitup';
import 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';

/* WADCMS
A décommenter si vous utilisez WadCms */
/* import '../../vendor/wad-commons/wad-cms/assets/js/app-cms'; */

/* WADGALLERY
A décommenter si vous utilisez WadGallery */
/* import '../../vendor/wad-commons/wad-gallery/assets/js/app-gallery'; */

/* GMAP
A décommenter si vous utilisez une Google Map */
/* import { Gmap } from './map'; */

$(document).ready(function(){
  // Tri listing
  // Conflit avec bootstrap : https://github.com/patrickkunka/mixitup/issues/268
  if ($('#Container').length > 0){
    var mixer = mixitup('#Container',{
      selectors: {
        control: '[data-mixitup-control]'
      }
    });

    $('.btnDesc').hide();
    $('.btn1').click(function(){
      $(this).hide();
      $('.btn2').fadeIn();
      $('.btn2').removeClass('hidden');
    });
    $('.btn2').click(function(){
      $(this).hide();
      $('.btn1').fadeIn();
      $('.btn1').removeClass('hidden');
    });
    $('.btn3').click(function(){
      $(this).hide();
      $('.btn4').fadeIn();
      $('.btn4').removeClass('hidden');
    });
    $('.btn4').click(function(){
      $(this).hide();
      $('.btn3').fadeIn();
      $('.btn3').removeClass('hidden');
    });
    $('.btn5').click(function(){
      $(this).hide();
      $('.btn6').fadeIn();
      $('.btn6').removeClass('hidden');
    });
    $('.btn6').click(function(){
      $(this).hide();
      $('.btn5').fadeIn();
      $('.btn5').removeClass('hidden');
    });
    $('.btn7').click(function(){
      $(this).hide();
      $('.btn8').fadeIn();
      $('.btn8').removeClass('hidden');
    });
    $('.btn8').click(function(){
      $(this).hide();
      $('.btn7').fadeIn();
      $('.btn7').removeClass('hidden');
    });
  }
});